(function() {
  'use strict';

  angular.module('eclipseApp.core').factory('timerService', [
    '$rootScope',
    '$state',
    '$timeout',
    '$log',
    '$modal',
    '$injector',
    function($rootScope, $state, $timeout, $log, $modal, $injector) {
      var timerService = {};
      var idleTimer = null;
      var maxMinutes = 1000 * 60 * 15;
      var SecmaxMinutes = 1000 * 60 * 5;
      //var maxMinutes = 1000 * 60 * 3;
      //var SecmaxMinutes = 1000 * 60 * 2;

      timerService.startTimer = function() {
        $log.log('Starting timer');
        idleTimer = $timeout(timerService.timerExpiring, maxMinutes);
      };

      timerService.SecstartTimer = function() {
        idleTimer = $timeout(timerService.timerExpiringSec, SecmaxMinutes);
      };
      timerService.stopTimer = function() {
        $log.log('Stoping timer');
        if (idleTimer) {
          $timeout.cancel(idleTimer);
        }
      };
      timerService.resetTimer = function() {
        $log.log('Reset timer');
        timerService.stopTimer();
        timerService.startTimer();
      };
      timerService.timerExpiring = function() {
        timerService.stopTimer();
        $rootScope.modal = $modal.open({
          templateUrl: 'modules/core/views/timer-modal-html.html',
          controller: 'timerModal',
          windowClass: 'timer-modal',
          size: 'sm',
          backdrop: 'static',
          keyboard: false,
          backdropClass: 'bkg-modal',
          resolve: {}
        });
        $log.log('Timer expiring ..');
        timerService.SecstartTimer();
      };

      timerService.timerExpiringSec = function() {
        timerService.stopTimer();
        timerService.cancelModel();
        $rootScope.$broadcast('timerModalOpen', { navigate: false });
        $rootScope.modal = $modal.open({
          templateUrl: 'modules/core/views/start-over-modal.html',
          controller: 'timerModal',
          windowClass: 'timer-modal',
          size: 'sm',
          backdrop: 'static',
          keyboard: false,
          backdropClass: 'bkg-modal',
          resolve: {}
        });
      };

      timerService.cancelModel = function() {
        if ($rootScope.modal) {
          $rootScope.modal.close();
        }
      };

      return timerService;
    }
  ]);
})();
